import { Notification } from 'element-ui';
import axios from 'axios';
import qs from 'qs'
 if (process.env.NODE_ENV !== 'production') {
     axios.defaults.baseURL = 'http://www.yhaiot.com:8096';
 }else {
    //axios.defaults.baseURL = 'http://www.yhaiot.com:8096';
    axios.defaults.baseURL = 'http://www.yhaiot.com:8096';
 }
axios.defaults.timeout = 500000;
//添加请求拦截器
axios.interceptors.request.use(
    function(config) {
        let headerToken = window.utils.storage.getter('headerToken')
        if (headerToken) {
            config.headers['token'] = headerToken;
        }
        config.headers['timestamp'] = Date.now();
        return config;
    },
    function(error) {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

//添加响应拦截器
axios.interceptors.response.use(
    function(response) {
        // 登陆失效, 清空本地存储后刷新页面
        if (response.data.code) {
            if (response.data.code === 11) {
                Notification({
                    title: '登录已过期,请重新登录',
                    type: 'error'
                });
                window.utils.storage.remove('userJson');
                window.utils.storage.remove('headerToken');
                setTimeout(() => {
                    window.location.href = window.location.origin
                }, 1000);
            }
            if (response.data.code !== 0) {
                Notification({
                    title: response.data.message || "未知错误",
                    type: 'error'
                });
                return Promise.reject(response.data);
            }
        }
        return response.data;
    },
    function(error) {
        Notification({
            title: error.message || "未知错误",
            type: 'error'
        });

        return Promise.reject(error);
    }
);

export default axios;